import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { GetUserSignatureResponse } from "./interfaces/get-user-signature";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getUserSignature(
  env: Environment,
  dealerId: number
): Promise<GetUserSignatureResponse> {
  const url = `${getBaseUrl(env)}cxm/user-signature?dealerId=${dealerId}`;
  const header = await getHeader();

  try {
    const response = await fetchWrapper.getAsync<GetUserSignatureResponse>(
      url,
      header
    );

    if (response && response.data && !response.hasError) {
      return response.data;
    } else {
      // eslint-disable-next-line no-console
      console.error("Error fetching user signature", response?.error);
      return {
        errorType: response?.statusCode === 404 ? "not_found" : "generic"
      };
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Exception fetching user signature", error);
    return { errorType: "generic" };
  }
}
